<template>
	<v-container
		fluid
		class="mx-0 px-0">
		<v-row
      class="mt-2 primary--text d-flex align-end justify-space-between">
      <v-col
        v-bind="columnsProps">
        <v-autocomplete
          v-model="filterOperationalRoutines.carrierId"
          v-bind="autoCompleteCarrierProps"
          label="Operadora*"
          :items="carriers"
          :rules="[rule.required]"
          hide-details
        />
      </v-col>
      <v-col
        v-bind="columnsProps">
        <v-autocomplete
          v-model="filterOperationalRoutines.financialGroupId"
          :label="isPreview ? 'Grupo financeiro*' : 'Grupo financeiro'"
          v-bind="autoCompleteProps"
          :items="financialGroups"
          hide-details
          :rules="isPreview ? [rule.required] : []"
        />
      </v-col>
      <v-col
        v-bind="columnsProps">
        <v-autocomplete
          v-model="filterOperationalRoutines.contractId"
          v-bind="autoCompleteProps"
          label="Contrato"
          :items="contracts"
          :loading="loadingContracts"
          hide-details
        />
      </v-col>
      <v-col
        v-bind="columnsProps">
        <v-autocomplete
          v-model="filterOperationalRoutines.subContractId"
          label="Subcontrato"
          v-bind="autoCompleteProps"
          :items="subContracts"
          :loading="loadingSubContracts"
          hide-details
        />
      </v-col>
      <v-col
        v-bind="columnsProps">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto">
          <template
            v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="filterOperationalRoutines.competencyDate"
              placeholder="Selecione"
              label="Competência*"
              readonly
              outlined
              dense
              hide-details
              v-bind="autoCompleteProps"
              v-on="on"
              :rules="[rule.required]"
            />
          </template>
          <v-date-picker
            @click="setCompetence"
            v-model="date"
            type="month"
            locale="pt-br"
            color="primary"
            no-title
            scrollable>
            <v-spacer />
            <v-btn
              text
              @click="cleanCompetence">
              LIMPAR
            </v-btn>
            <v-btn
              text
              @click="setCompetence">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        v-bind="columnsProps"
        v-show="isPreview">
        <v-menu
          ref="menuIssueDate"
          v-model="menuIssueDate"
          :close-on-content-click="false"
          transition="scale-transition"
          min-width="auto">
          <template
            v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="issueDate"
              prepend-inner-icon="mdi-calendar"
              outlined
              dense
              :label="isPreview && !inSearch ? 'Data de emissão da fatura*' : 'Data de emissão da fatura'"
              readonly
              hide-details
              v-bind="attrs"
              v-on="on"
              :rules="isPreview && !inSearch ? [rule.required] : []"
            />
          </template>
          <v-date-picker
            v-model="filterOperationalRoutines.issueDate"
            locale="pt-br"
            color="primary"
            no-title
            scrollable>
            <v-spacer />
          <v-btn
            text
            @click="cleanIssueDate">
            LIMPAR
          </v-btn>
          <v-btn
            text
            @click="saveIssueDate">
            OK
          </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        v-bind="columnsProps"
        v-show="isPreview">
        <v-menu
          ref="menuCutOffDate"
          v-model="menuCutOffDate"
          :close-on-content-click="false"
          transition="scale-transition"
          min-width="auto">
          <template
            v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="cutOffDate"
              prepend-inner-icon="mdi-calendar"
              outlined
              dense
              :label="isPreview && !inSearch ? 'Período de Corte*' : 'Período de Corte'"
              readonly
              hide-details
              v-bind="attrs"
              v-on="on"
              :rules="isPreview && !inSearch ? [rule.required] : []"
            />
          </template>
          <v-date-picker
            v-model="dates"
            locale="pt-br"
            color="primary"
            no-title
            scrollable
            range>
            <v-spacer />
          <v-btn
            text
            @click="cleanCutOffDate">
            LIMPAR
          </v-btn>
          <v-btn
            text
            @click="saveCutOffDate">
            OK
          </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        class="d-flex align-center"
        style="height: 50px;"
        v-bind="columnsProps"
        v-if="isPreview">
        <v-switch
          v-model="filterOperationalRoutines.groupLast"
          label="Trazer a última geração de prévia"
          class="ma-0 mt-2 pa-0"
        />
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col
        class="d-flex justify-end align-center"
        cols="12" sm="4" md="3" lg="3"
        v-if="isPreview"
        :order="isPreview ? 2 : 1">
        <v-btn
          class="foreground-accent--text rounded-pill"
          height="39px"
          width="100%"
          max-width="350"
          color="primary"
          :disabled="loadingSearch"
          @click="generatePreview()"
          :loading="loadingPreviewGeneration">
          Gerar Prévia
        </v-btn>
      </v-col>
      <v-col
        cols="12" sm="4" md="3" lg="3" :offset-sm="isPreview ? 0 : 4" :offset-md="isPreview ? 3 : 6" :offset-lg="isPreview ? 3 : 6"
        :order="isPreview ? 1 : 2"
        class="d-flex justify-end align-center"
        style="max-height: 40px;">
        <span
          class="text-decoration-underline mr-2 primary--text"
          style="cursor: pointer;"
          @click="clearFilterOperationalRoutines">
          Limpar pesquisa
        </span>
      </v-col>
      <v-col
        class="py-0 d-flex justify-end align-center"
        cols="12" xs="12" sm="4" md="3" lg="3"
        order="3">
        <v-btn
          class="foreground-accent--text rounded-pill"
          height="39px"
          width="100%"
          max-width="350"
          color="primary"
          @click="search()"
          :disabled="loadingPreviewGeneration"
          :loading="loadingSearch">
          Pesquisar
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      v-show="overlay"
      class="primary--text my-15">
      <v-col
        cols="12"
        class="d-flex justify-center">
        <v-progress-circular
          color="primary"
          indeterminate
          size="64"
          width="8"
        />
      </v-col>
      <v-col
        cols="12"
        class="d-flex justify-center">
        Carregando Filtros
      </v-col>
    </v-row>
	</v-container>
</template>

<script>
import OperationalRoutinesMixin from '@/shared/mixins/operationalRoutines/operationalRoutinesMixin';
import InsuranceCarriersMixin from '@/shared/mixins/sdi/insuranceCarriersMixin';
import FinancialGroupsMixin from '@/shared/mixins/sdi/financialGroupsMixin';
import ContractsMixin from '@/shared/mixins/sdi/contractsMixin';
import DataLoadService from '@/services-http/sdi/DataLoadService';

import operationalRoutinesModule from '@/store/modules/operational-routines/operational-routines-module';

import Rules from '@/shared/validators/formRules';

import moment from 'moment';
import { cloneDeep } from 'lodash';
import { mapMutations } from 'vuex';

export default {
	name: "SimpleFilter",

	data: () => ({
    overlay: false,
    menuIssueDate: false,
    menuCutOffDate: false,
    loadingContracts: false,
    loadingSubContracts: false,
    watcherCalledGetContract: false,
    watcherCalledGetSubContract: false,
    days: Array.from({ length: 31 }, (_, i) => i + 1),
    carriers: [],
    dates: [],
    issueDate: null,
		moment: moment,
    dataLoadService: null,
    cutOffDate: null,
		rule: null,
		menu: null,
		date: null,

		columnsProps: {
			 cols: "12",
			 sm: "6",
			 md: "3",
			 lg:"3",
		},

		autoCompleteProps: {
			class: "mt-1",
			placeholder: "Selecione",
			itemText: "name",
			itemValue: "id",
			outlined: true,
			clearable: true,
			dense: true,
			color: "primary--text",
			itemColor: "primary--text",
		},
		autoCompleteCarrierProps: {
			class: "mt-1",
			placeholder: "Selecione",
			itemText: "carrierName",
			itemValue: "carrierId",
			outlined: true,
			clearable: true,
			dense: true,
			color: "primary--text",
			itemColor: "primary--text",
		},

		insuranceCarriers: [],
    financialGroups: [],
    contracts: [],
    subContracts: [],
	}),

	mixins: [
		OperationalRoutinesMixin,
		InsuranceCarriersMixin,
    FinancialGroupsMixin,
    ContractsMixin,
	],

	props: {
    loadingPreviewGeneration: {
      type: Boolean,
			default: false
    },
    loadingSearch: {
      type: Boolean,
			default: false
    },
    isPreview: {
      type: Boolean,
			default: false
    },
    inSearch: {
      type: Boolean,
			default: false
    },
    parameters: {
      type: Object,
      default: () => {}
    },
	},

	watch: {
		date: {
      deep: true,
      handler(value) {
        if (value) this.setCompetence();
      },
    },
    'filterOperationalRoutines.financialGroupId': {
      deep: true,
      handler(value) {
        const financialGroupId = cloneDeep(value);
        if (financialGroupId) {
          if (!this.watcherCalledGetContract) {
            this.loadContractsByFinancialGroupId(financialGroupId);
          }
        } else {
          this.contracts = [];
          this.subContracts = [];
          this.watcherCalledGetContract = false;
        }
      },
    },
    'filterOperationalRoutines.contractId': {
      deep: true,
      handler(value) {
        if (value) {
          if (!this.watcherCalledGetSubContract) {
            this.loadSubContractsByContractId(value);
          }
        } else {
          this.subContracts = [];
          this.watcherCalledGetSubContract = false;
        }
      },
    },
	},

	methods: {
    ...mapMutations({
      cleanContractsSelected: 'operational-routines/cleanContractsSelected',
    }),
    cleanCutOffDate() {
      this.cutOffDate = null;
      this.dates = null;
    },
    cleanIssueDate() {
      this.filterOperationalRoutines.issueDate = null;
      this.issueDate = null;
    },
    saveCutOffDate() {
      if (this.dates.length === 2) {
        this.sortDates();

        if (!this.validateDateRange(this.dates)) return;

        const startDate = moment(this.dates[0], 'YYYY-MM-DD').format('DD/MM/YYYY');
        const endDate = moment(this.dates[1], 'YYYY-MM-DD').format('DD/MM/YYYY');

        this.cutOffDate = `${startDate} à ${endDate}`;
        this.$emit('updateCutOffDate', this.dates);
        this.menuCutOffDate = false;
      } else {
        this.$refs.SnackbarCustomize.open('error', 'Defina um período para entre datas a Data de Corte.');
      }
    },
    saveIssueDate() {
      if (this.filterOperationalRoutines.issueDate) {
        const issueDate = moment(this.filterOperationalRoutines.issueDate, 'YYYY-MM-DD').format('DD/MM/YYYY');

        this.issueDate = issueDate;
        this.menuIssueDate = false;
      }
    },
    sortDates() {
      this.dates.sort((a, b) => new Date(a) - new Date(b));
    },
    validateDateRange(dates) {
      const [start, end] = dates;
      const startDate = new Date(start);
      const endDate = new Date(end);
      const diffTime = Math.abs(endDate - startDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays > 60) {
        this.$refs.SnackbarCustomize.open('error', 'Defina um período máximo de 60 dias para a Data de Corte.');
        return false;
      }
      return true;
    },
    async setMandatoryCarriers() {
			await this.dataLoadService.GetAllConfigMandatoryExtFile().then(res => {
				if (res.data.length > 0) {
					let mandatoryCarriers = [];
					res.data.forEach((carrier, index) => {
						if (index === 0 && carrier.carrierId != null) {
							mandatoryCarriers.push(carrier);
						}
						if (
							carrier.carrierId != null
							&& !mandatoryCarriers.some(item => item.carrierId === carrier.carrierId)
						) {
							mandatoryCarriers.push(carrier);
						}
					});
					mandatoryCarriers.sort((a, b) => (a.carrierName > b.carrierName ? 1 : -1));

          this.carriers = mandatoryCarriers;
				}
			})
		},
    search() {
      this.cleanIssueDate();
      this.cleanCutOffDate();
      this.cleanContractsSelected();
      this.$emit('inSearch', true)
      setTimeout(() => {
        this.$emit('search', this.filterOperationalRoutines);
      }, 500)
    },
    generatePreview() {
      this.cleanContractsSelected();
      setTimeout(() => {
        this.$emit('generatePreview', this.filterOperationalRoutines);
      }, 500)
    },
		setCompetence() {
			if (Boolean(this.date)) {
				this.filterOperationalRoutines.competencyDate = moment(this.date, 'YYYY-MM').format('MM/YYYY');
			}
      this.menu = false;
    },
		cleanCompetence() {
      this.filterOperationalRoutines.competencyDate = null;
			this.date = null;
    },
		clearFilterOperationalRoutines() {
			this.updateFilterFields({}, true);
      this.cleanIssueDate();
      this.cleanCutOffDate();
      this.filterOperationalRoutines.groupLast = false;
			this.$forceUpdate();
			this.$emit("resetStatusFilters", false)
		},
		updateFilterFields(data, cleanFields = false) {
			const fields = ["carrierId", "competencyDate", "financialGroupId", "contractId", "issueDate"];
			fields.forEach(field => {
				if (cleanFields) {
					this.filterOperationalRoutines[field] = null;
				} else if (data.hasOwnProperty(field)) {
					this.filterOperationalRoutines[field] = data[field];
				}
			})
		},
    loadContractsByFinancialGroupId(financialGroupId) {
      return new Promise((resolve) => {
        this.getContractsByFinancialGroupId(financialGroupId).then(() => {
          resolve();
        });
      });
    },
    async loadSubContractsByContractId(contractId) {
      return new Promise((resolve) => {
        this.getSubContractsByContractId(contractId).then(() => {
          resolve();
        });
      });
    },
    loadParameters() {
      if (this.parameters.carrierId) this.filterOperationalRoutines.carrierId = Number(this.parameters.carrierId);
      if (this.parameters.financialGroupId) this.filterOperationalRoutines.financialGroupId = Number(this.parameters.financialGroupId);
      if (this.parameters.contractId) this.filterOperationalRoutines.contractId = Number(this.parameters.contractId);
      if (this.parameters.competencyDate) this.filterOperationalRoutines.competencyDate = moment(this.parameters.competency, 'YYYY-MM').format('MM/YYYY');
      this.search();
    },
	},

	computed: {
		getInvoiceCarrierTypes() {
			return operationalRoutinesModule.invoiceTypes;
		},
	},

	created() {
		this.rule = new Rules();
    this.dataLoadService = new DataLoadService();
	},

	async mounted() {
    this.overlay = true;
    await this.getFinancialGroups();
    await this.setMandatoryCarriers();
    this.loadParameters();
    this.overlay = false;
	},
}
</script>
